<!-- footer -->
<mat-divider></mat-divider>
<footer>
    &copy; All rights reserved 2022
</footer>